import { artistsTemplate } from './artists'
import { artworksTemplate } from './artworks'
import { defaultTemplate } from './default'
import { signupTemplate } from './signup'
import { teamTemplate } from './team'
import { tradingFloorTemplate } from './tradingFloor'
import type { PageTemplateModule } from './types'

/**
 * Page Template Registry
 * Maps template identifiers to template modules
 */
export const PAGE_TEMPLATES: Record<string, PageTemplateModule> = {
  default: defaultTemplate,
  team: teamTemplate,
  signup: signupTemplate,
  artworks: artworksTemplate,
  artists: artistsTemplate,
  'trading-floor': tradingFloorTemplate,
}

export type TemplateType = keyof typeof PAGE_TEMPLATES

/**
 * Get template module by name with fallback to default
 * @param templateName - The template identifier from Sanity
 * @returns Template module
 */
export function getTemplate(templateName?: string): PageTemplateModule {
  if (!templateName) {
    console.warn('[PageTemplate] No template specified, using default')
    return PAGE_TEMPLATES.default
  }

  if (!PAGE_TEMPLATES[templateName]) {
    console.error(
      `[PageTemplate] Template '${templateName}' not found, using default`
    )
    return PAGE_TEMPLATES.default
  }

  return PAGE_TEMPLATES[templateName]
}

// Re-export types
export type { BasePageData, PageTemplateModule, TemplateParams } from './types'
